import React from 'react';
import { snakeCase } from 'lodash';

import './organizationIcon.scss';

interface Props {
    organizationName: string;
}

const OrganizationIcon: React.FC<Props> = ({ organizationName }) => {
    try {
        const name = snakeCase(organizationName.toLowerCase());
        // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require,import/no-dynamic-require
        const icon = require(`assets/organizations/${name}.png`);

        return (
            <img
                styleName="icon"
                className="__app-OrganizationIcon-icon"
                src={icon}
                alt=""
            />
        );
    } catch (e) {
        return null;
    }
};

export default OrganizationIcon;
